export class LogoutAction {
  static type = '[USER] Logout';
}
